module.exports = __webpack_public_path__ + "static/media/sportAvatar__overwatch.08f61e1b.jpg";